import { connect } from 'react-redux';

const mapStateToProps = state => ({
  urls: state.mainreducer.urls,
});

export default ListViewRightPart => connect(mapStateToProps, null)(ListViewRightPart);
